import axios from 'axios';
import baseUrl from '../config/baseURL';
import { getAuthToken } from '../services/auth';

export const getInstagramConversations = async (organization_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: 'Bearer ' + token.data };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/instagram-conversations`;
      const response = await axios.get(endpoint, { headers });

      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response.data };
      } else {
        console.error('Failed to retrieve conversations:', response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error fetching conversations:', error);
    return { success: false, data: error };
  }
};

export const searchInstagramConversation = async (
  organization_id: string,
  search_key: string,
) => {
  let token = await getAuthToken();

  if (!token) {
    return { success: false, data: 'Token does not exist' };
  }

  const headers = {
    Authorization: `Bearer ${token.data}`,
  };

  try {
    const endpoint = `${baseUrl}/core/organizations/${organization_id}/instagram-conversations/?search=${encodeURIComponent(
      search_key,
    )}`;

    const response = await axios.get(endpoint, { headers });

    if (response.status >= 200 && response.status < 400) {
      return { success: true, data: response.data };
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.error('Unexpected error:', error);
    return { success: false, data: error };
  }
};

export const getInstagramConversation = async (
  organization_id: any,
  conversation_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: 'Bearer ' + token.data };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/instagram-conversations/${conversation_id}/`;
      const response = await axios.get(endpoint, { headers });
      console.log('Instagram conversation fetch response', response);

      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response.data };
      } else {
        console.error('Failed to retrieve conversations:', response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error fetching conversations:', error);
    return { success: false, data: error };
  }
};

// Get messages for a specific Instagram conversation
export const getInstagramMessages = async (
  organization_id: any,
  conversation_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: 'Bearer ' + token.data };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/instagram-conversations/${conversation_id}/messages`;
      const response = await axios.get(endpoint, { headers });

      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response.data };
      } else {
        console.error('Failed to retrieve messages:', response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error fetching messages:', error);
    return { success: false, data: error };
  }
};

// Send a message in an Instagram conversation
export const sendInstagramMessage = async (
  organization_id: any,
  conversation_id: any,
  text: string,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = {
        Authorization: 'Bearer ' + token.data,
        'Content-Type': 'application/json',
      };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/instagram-conversations/${conversation_id}/messages/send/`;
      const response = await axios.post(endpoint, { text }, { headers });
      console.log('response', response);

      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response.data };
      } else {
        console.error('Failed to send message:', response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error sending message:', error);
    return { success: false, data: error };
  }
};

// Delete an Instagram message
export const deleteInstagramMessage = async (
  organization_id: any,
  conversation_id: any,
  message_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: 'Bearer ' + token.data };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/instagram-conversations/${conversation_id}/messages/${message_id}/`;
      const response = await axios.delete(endpoint, { headers });

      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response.data };
      } else {
        console.error('Failed to delete message:', response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error deleting message:', error);
    return { success: false, data: error };
  }
};

// Get an Instagram user profile
export const getInstagramUserProfile = async (organization_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: 'Bearer ' + token.data };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/instagram-account`;
      const response = await axios.get(endpoint, { headers });
      console.log('Instagram profile response', response);

      if (response.status >= 200 && response.status < 400) {
        if (response.data && Object.keys(response.data).length > 0) {
          return { success: true, data: response.data };
        } else {
          console.warn('No Instagram account data found for this organization');
          return { success: false, data: null };
        }
      } else {
        console.error('Failed to fetch user profile:', response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error fetching profile:', error);
    return { success: false, data: error };
  }
};

export const disconnectInstagramUserProfile = async (
  organization_id: any,
  profile_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: 'Bearer ' + token.data };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/instagram-account/${profile_id}/`;
      const response = await axios.delete(endpoint, { headers });
      console.log('Instagram profile response', response);

      if (response.status >= 200 && response.status < 400) {
        if (response.data && Object.keys(response.data).length > 0) {
          return { success: true, data: response.data };
        } else {
          console.warn('No Instagram account data found for this organization');
          return { success: false, data: null };
        }
      } else {
        console.error('Failed to fetch user profile:', response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error fetching profile:', error);
    return { success: false, data: error };
  }
};

// Delete an Instagram conversation
export const deleteInstagramConversation = async (
  organization_id: any,
  conversation_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: 'Bearer ' + token.data };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/instagram-conversations/${conversation_id}/`;
      const response = await axios.delete(endpoint, { headers });

      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response.data };
      } else {
        console.error('Failed to delete instagram conversation:', response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error deleting instagram conversation:', error);
    return { success: false, data: error };
  }
};

export const toggleInstagramAiChatResponses = async (
  organization_id: any,
  account_id: any,
  enabled: boolean,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = 'Bearer ' + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/instagram-account/${account_id}/toggle-ai-chats/`;
        const response = await axios.post(endpoint, { enabled }, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        }
        return { success: false, data: response?.data };
      } catch (error) {
        console.error('Unexpected error (toggle chat AI):', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred:', error);
    return { success: false, data: undefined };
  }
};
